import { LinearRange } from './linear_range';
import { DiscreteRange } from './discrete_range';

const TIME_RANGE = 'timeRange';
const MAP_TIME = 'mapTime';

const LINEAR = 'LINEAR';
const DISCRETE = 'DISCRETE';

export {
	TIME_RANGE,
	MAP_TIME,
	LinearRange,
	DiscreteRange,
	LINEAR,
	DISCRETE
}